import { post,put,del,get } from './axios'

export const getUnionDetail = async (params) => {
  const { status, data } = await get("/union/selectUnionNewDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const unionList = async (params) => {
  const { status, data } = await get("/union/selectUnionNewAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const updateViewCount = async (params) => {
  const { status, data } = await post("/union/updateViewCountAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}